/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const unitBase = 4;
export const rowSpacing = unitBase * 3; // 12px
export const rowSpacingDesktop = unitBase * 2.5; // 10px

export const fontSize = {
    micro: 9,
    small: 12,
    body: 14,
    component: 16,
    h2: 14,
    h1: 20,
    large: 18,
    larger: 24,
    largest: 32,
};

export const fontSizeDesktop = {
    micro: 9,
    small: 12,
    body: 14,
    component: 16,
    title: 16,
    h2: 16,
    h1: 20,
    large: 20,
    larger: 24,
    largest: 32,
};

export const enterpriseCSS = {
    palette: {
        body: '#000000',
        black: '#000000',
        blue: '#4A90E2',
        gray1: '#7C7C7D',
        gray2: '#D8D8D8',
        gray3: '#EDEDEA',
        green: '#64B00C',
        red: '#D0021B',
        white: '#FFFFFF',
        success: '#25C066',
        error: '#D0021B',
        darkRed: '#a1001a',
        hoverRed: '#790000',
        darkGray: '#161616',
        checkbox: '#797979',
        button: {
            darkGray: '#2f2f2f',
        },
        base: {
            h2Divider: {
                color: '#7C7C7D',
                backgroundColor: '#EDEDEA',
            },
        },
        modal: {
            title: {
                size: 18,
                color: '#7C7C7D',
                backgroundColor: '#EDEDEA',
            },
        },
    },
};

export const paletteHD = {
    // replacement keys for clarity and versatility
    colorPrimary: '#1f1f1b', // replaces cta1
    colorPrimaryContrast: '#fff',
    colorSecondary: '#1f1f1b', // replaces cta2
    colorSecondaryContrast: '#fff',
    colorTertiary: '#1f1f1b', // replaces cta3
    colorTertiaryContrast: '#fff',
    colorQuaternary: '#1f1f1b', // replaces cta4
    colorQuaternaryContrast: '#fff',
    colorQuinary: '#1f1f1b', // added for flexibility
    colorQuinaryContrast: '#fff',

    colorNeutral: '#1f1f1b', // replaces gray*
    colorNeutral10: '#fafafa', // begin alpha variants
    colorNeutral20: '#f5f5f5',
    colorNeutral30: '#eee',
    colorNeutral40: '#e0e0e0',
    colorNeutral50: '#bdbdbd',
    colorNeutral60: '#9e9e9e',
    colorNeutral70: '#757575',
    colorNeutral80: '#373737',
    colorNeutral90: '#1b1b1b', // end alpha variants

    colorInfo: '#1976d2',
    colorInfoContrast: '#fff',
    colorWarning: '#ffa000',
    colorWarningContrast: '#fff',
    colorAlert: '#a1001a',
    colorAlertContrast: '#fff',
    colorSuccess: '#43a047',
    colorSuccessContrast: '#fff',
    colorDisabled: '#ccc',
    colorDisabledContrast: '#1f1f1b',

    // existing acceptable values
    black: '#1f1f1b',
    white: '#fff',
    bgFooter: '#f2f2f2',
    bgHeader: 'white',
    bgPhoneIcon: '#a1001a',
    bgPopup: 'rgba(0,0,0,.85)',
    bgSelected: 'rgba(48,69,98,.1)',
    bgTile1: '#a1001a',
    bgTile2: '#2f2f2f',
    bigBoldLabel: '#595959',
    bgTextOverlay1: 'rgba(0,0,0,0.6)',
    colorIconHeader: '#000',
    disableButton: '#d8d8d8',
    error: { main: '#ff0000' },
    gfBgColor: '#9872bb',
    gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
    gfMobileLabelTextColor: '#212121',
    gfMobileSelectOptionTextColor: '#606060',
    gfMobileZipInputLabelTextColor: '#a0a0a0',
    gfTabDesktopInputBorder: '1px solid #333',
    globalBannerBackgroundColor: 'black',
    globalBannerTextColor: 'white',
    globalBannerTextDecoration: 'none',
    linkMenu: '#595959',
    orderConfirmationHeader: '#595959',
    orderConfirmationText: 'black',
    primary: {
        500: '#595959',
    },
    primaryButton: '#a1001a',
    productTitleColor: '#2f2f2f',
    sectionHeaderTextColor: '#202020',
    secondaryButton: '#595959',
    shape: {
        borderRadius: '4px',
    },
    tickCheck: '#00CC33',
    snipeText: '#3c3c35',
    snipeTextPromo: '#a1001a',
    snipeTextBackground: 'rgba(255,255,255,0.82)',
    snipeTextFontSize: '14px',
    snipeTextFontWeight: 500,
    pdp: {
        subscription: {
            checkboxColor: '#3D70B2',
            rootContainerBackground: '#efdfb0',
            boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
            overlayContainerBackground: '#fff',
            modalColor: '#fff',
            subTable: '#f7eed7',
            linkColor: '#304562',
            goButton: '#a1001a',
            goButtonColor: '#fff',
        },
    },
    mobileMenuBG: {
        header: '#909090',
        main: '#fff',
        product: '#fff',
        alternate: '#909090',
        nonProduct: '#909090', // DEPRECATED- replaced by 'alternate'
        parent: '#909090',
        child: '#e8e8e8',
        leftMenuBG: '#909090',
    },
    desktopHeaderMenu: {
        // TODO: replace this with brand's real values
        background: '#f4f2f7',
        text: '#333',
        border: '1px solid #f5f5f5',
        maxWidth: '1400px',
    },
    uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
    unCheckRadioBtn: '#595959',
    checkRadioBtn: '#a1001a',
    copyright: '#747472',
    mobileFooterBottomLink: '#747472',
    desktopBgFooter: '#f2f2f2',
    modalBg: '#f2f2f2',
    modalTile: '#f2f2f2',

    // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
    // OK to modify values as long as replacement is updated as well (unless specifically noted)
    cta1: '#2f2f2f', // DEPRECATED
    cta2: '#a94', // DEPRECATED
    cta3: '#3c3c35', // DEPRECATED
    cta4: '#595959', // DEPRECATED
    pink1: '#8E1429', // DEPRECATED
    brown1: '#5b322c', // DEPRECATED
    brown2: '#311714', // DEPRECATED
    brown3: '#600600', // DEPRECATED
    brown4: '#d9d0c1', // DEPRECATED
    brown5: 'rgba(255,255,255,0.82)', // DEPRECATED
    brown6: '#ded8d8', // DEPRECATED
    grey1: '#2f2f2f', // DEPRECATED
    grey2: '#3c3c35', // DEPRECATED
    grey3: '#5c5c52', // DEPRECATED
    grey4: '#7c7c70', // DEPRECATED
    grey5: '#909090', // DEPRECATED
    grey6: '#d1d1c1', // DEPRECATED
    grey7: '#e3e3e3', // DEPRECATED
    grey8: '#cccccc', // DEPRECATED
    grey9: '#e8eaec', // DEPRECATED
    grey10: '#595959', // DEPRECATED
    grey11: '#e4e4e4', // DEPRECATED
    myAccount: {
        contentGridBorder: '#7c7c7d',
        blockBorderRight: '#e2e2e2',
        blockMessageFadedInside: '#7c7c7d',
        blockHeaderbackground: '#ededea',
        blockActions: '#619ee6',
        caretSign: '#000',
        activeLink: '#000',
        divider: '#ccc',
        orderRow: '#f6f6f4',
        container: {
            backgroundColor: 'transparent',
            maxWidth: {
                downSmall: '100%',
                downMedium: '100%',
                upMedium: '970px',
                upLarge: '1170px',
            },
        },
    },
    tiers: {
        card: {
            backgroundColor: '#fff',
        },
        image: {
            maxWidth: '100%',
            height: 'auto',
        },
        title: {
            lineHeight: '42px',
            color: '#fff',
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            upSmall: {
                textAlign: 'left',
            },
            downSmall: {
                textAlign: 'center',
            },
        },
        container: {
            backgroundColor: 'transparent',
            maxWidth: {
                downSmall: '100%',
                downMedium: '100%',
                upMedium: '970px',
                upLarge: '1170px',
            },
        },
    },
};

// eslint-disable-next-line object-curly-newline
export default { rowSpacing, fontSize, fontSizeDesktop, paletteHD };
